@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in">
      <div class="leading-6 font-medium font-bold justify-center mb-4">{{ field.label | localize }}</div>
      <mat-accordion class="w-full">
        @for (form of field.embeddedForms; track form; let i = $index) {
          <mat-expansion-panel [ngClass]="{'error-panel': controlHasErrors(form)}" class="mb-4 " (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="font-bold font-large text-lg mx-2">{{ $safeNavigationMigration(options[i]?.value) | localize }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (field && !isHide(options[i])) {
              <dtype-component-list class="w-full" [dtypeForm]="form"
                [isUpdate]="isUpdate">
              </dtype-component-list>
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
      @if (field.hint) {
        <div class="text-md text-secondary">{{ field.hint | localize }}</div>
      }
      @if (!field.readonly &&
        field.control.touched &&
        field.control.errors) {
        @if (field.control.hasError('required')) {
          <div class="text-sm text-warn leading-none font-medium">
            {{ 'errorRequiredField' | transloco }}
          </div>
        }
        @if (field.control.hasError('minlength')) {
          <div class="text-sm text-warn leading-none font-medium">
            {{ 'errorMinLengthField' | transloco:{ requiredLength: field.control.errors.minlength.requiredLength
            } }}
          </div>
        }
        @if (field.control.hasError('maxlength')) {
          <div class="text-sm text-warn leading-none font-medium">
            {{ 'errorMaxLengthField' | transloco:{ requiredLength: field.control.errors.maxlength.requiredLength
            } }}
          </div>
        }
      }
    </div>
  }
}